// src/configs/centerSceneConfigs.js
export const centerSceneConfigs = {
  "ql-ho-so": {
    image: "/images/center/ql-ho-so.jpg",
    view: {
      fov: 70,
      pitch: 0,
      yaw: 0,
    },
  },
  "truy-xuat-ng-goc": {
    image: "/images/center/truy-xuat-ng-goc.jpg",
    view: {
      fov: 73.41,
      pitch: 22.82,
      yaw: -72.1,
    },
  },
  "tim-kiem-n-cao": {
    image: "/images/center/tim-kiem-n-cao.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "danh-gia-phan-hoi": {
    image: "/images/center/danh-gia-phan-hoi.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "bao-cao-phan-tich": {
    image: "/images/center/bao-cao-phan-tich.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "ql-san-pham-dich-vu": {
    image: "/images/center/ql-san-pham-dich-vu.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "ql-chung-chi": {
    image: "/images/center/ql-chung-chi.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "ket-noi-giao-dich": {
    image: "/images/center/ket-noi-giao-dich.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "don-hang-thanh-toan": {
    image: "/images/center/don-hang-thanh-toan.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
  "tich-hop-api-mo": {
    image: "/images/center/tich-hop-api-mo.jpg",
    view: {
      fov: 73.41,
      pitch: 0,
      yaw: 0,
    },
  },
};
